import * as React from 'react';
import classNames from 'classnames';
import {Text, TextProps, TextType} from '../Text';
import style from './link.scss';

export interface LinkProps extends TextProps {
  url?: string;
  type?: TextType;
  newTab?: boolean;
  forcePink?: boolean;
  resetMargin?: boolean;
}

export function Link({
  url = '',
  type = 'link',
  text = '',
  newTab = false,
  className,
  forcePink = false,
  resetMargin = true,
  ...restProps
}: LinkProps) {
  return (
    <Text
      href={url || `https://${text}`}
      text={text}
      type={type}
      target={newTab ? '_blank' : '_self'}
      className={classNames(
        className,
        style.link,
        resetMargin && style.resetMargin,
        forcePink && style.forcePink,
      )}
      component="a"
      {...restProps}
    />
  );
}

export default Link;
